import { OrderStatus } from "./OrderStatus";

// "Statut Commande" — distinct from "Statut livraison" (OrderStatus). Not stored as its own
// enum: derived from the delivery status plus the `closed` flag on the order.
export enum OrderState {
  ACTIVE = "active",
  CLOSED = "closed",
  CANCELED = "canceled",
}

export const ORDER_STATE_LABELS: Record<OrderState, string> = {
  [OrderState.ACTIVE]: "Actif",
  [OrderState.CLOSED]: "Clôturé",
  [OrderState.CANCELED]: "Annulé",
};

export const getOrderState = (
  status?: OrderStatus,
  closed?: boolean
): OrderState => {
  if (status === OrderStatus.CANCELED) return OrderState.CANCELED;
  return closed ? OrderState.CLOSED : OrderState.ACTIVE;
};
